import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { MARKETING_QUERY } from "graphql/marketing";

// Bearer token is stored by auth flow in localStorage
const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

// Apollo Client instance for marketing service
let marketingClient = null;

/**
 * Initialize Apollo Client for marketing service
 * @returns {ApolloClient} Configured Apollo Client instance
 */
const getMarketingClient = () => {
  if (marketingClient) {
    return marketingClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  marketingClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return marketingClient;
};

export async function fetchMarketing(timePeriod = "YTD", highlightsTimePeriod = "YTD", filters = {}) {
  try {
    const client = getMarketingClient();

    const { data } = await client.query({
      query: MARKETING_QUERY,
      variables: {
        filters,
        marketingFilters: filters
      },
      fetchPolicy: "network-only",
    });

    console.log("Marketing GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Marketing GraphQL error:", error);
    throw error;
  }
}
